import type { Template } from "@/types";

export const SQ_06_H4_V2: Template[] = [
    {
        id: "sq-06-h4v2-01",
        name: "SQ 01 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 67, y: 75, width: 582, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 518, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 518, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 461, y: 518, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 779, y: 137, width: 298, height: 444, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1085, y: 137, width: 298, height: 444, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h4v2-02",
        name: "SQ 02 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 67, y: 75, width: 582, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 455, width: 287, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 362, y: 455, width: 287, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 881, y: 75, width: 389, height: 264, rotation: 0, imageRotation: 0 },
            { id: "5", x: 881, y: 347, width: 190, height: 294, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 347, width: 190, height: 294, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h4v2-03",
        name: "SQ 03 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 83, y: 52, width: 255, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 83, y: 446, width: 150, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 346, y: 52, width: 287, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 346, y: 249, width: 288, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 241, y: 446, width: 393, height: 218, rotation: 0, imageRotation: 0 },
            { id: "6", x: 772, y: 137, width: 607, height: 443, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h4v2-04",
        name: "SQ 04 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 74, width: 812, height: 569, rotation: 0, imageRotation: 0 },
            { id: "2", x: 890, y: 74, width: 187, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 890, y: 363, width: 187, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1085, y: 74, width: 279, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1085, y: 267, width: 279, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1085, y: 459, width: 279, height: 184, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h4v2-05",
        name: "SQ 05 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_05.png",
        size: [1434, 717],
        style: {},
        slots: [        
            { id: "1", x: 0, y: 102, width: 369, height: 252, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 362, width: 369, height: 252, rotation: 0, imageRotation: 0 },
            { id: "3", x: 377, y: 102, width: 369, height: 252, rotation: 0, imageRotation: 0 },
            { id: "4", x: 377, y: 362, width: 369, height: 252, rotation: 0, imageRotation: 0 },
            { id: "5", x: 754, y: 102, width: 336, height: 512, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1098, y: 102, width: 336, height: 512, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h4v2-06",
        name: "SQ 06 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 37, y: 160, width: 271, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 517, y: 160, width: 271, height: 397, rotation: 0, imageRotation: 0 },
            { id: "3", x: 316, y: 160, width: 193, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 316, y: 295, width: 193, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 316, y: 430, width: 193, height: 127, rotation: 0, imageRotation: 0 },
            { id: "6", x: 796, y: 160, width: 601, height: 397, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h4v2-07",
        name: "SQ 07 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 76, width: 569, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 453, width: 281, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 453, width: 280, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 76, width: 307, height: 565, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1082, y: 76, width: 302, height: 181, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1082, y: 265, width: 302, height: 376, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h4v2-08",
        name: "SQ 08 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 174, width: 569, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 785, y: 518, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 982, y: 518, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1178, y: 518, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 785, y: 76, width: 287, height: 434, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 76, width: 286, height: 434, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h4v2-09",
        name: "SQ 09 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 108, y: 121, width: 316, height: 475, rotation: 0, imageRotation: 0 },
            { id: "2", x: 432, y: 121, width: 177, height: 109, rotation: 0, imageRotation: 0 },
            { id: "3", x: 432, y: 238, width: 177, height: 109, rotation: 0, imageRotation: 0 },
            { id: "4", x: 432, y: 355, width: 177, height: 241, rotation: 0, imageRotation: 0 },
            { id: "5", x: 898, y: 121, width: 355, height: 234, rotation: 0, imageRotation: 0 },
            { id: "6", x: 898, y: 363, width: 355, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h4v2-10",
        name: "SQ 10 - H4V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h4_v2_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 95, y: 46, width: 467, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 95, y: 362, width: 467, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 570, y: 46, width: 344, height: 507, rotation: 0, imageRotation: 0 },
            { id: "4", x: 570, y: 561, width: 168, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 746, y: 561, width: 168, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 922, y: 46, width: 416, height: 625, rotation: 0, imageRotation: 0 }
        ],
    },
];

